export default __webpack_public_path__ + "static/media/customer.2ff13bb7.png";